import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {triggerDetailPopup, WORD_HELP_POPUP_PADDING} from "../../defines/client.const";
import { RECORDER_HELP_BBS_ID } from '../../defines/gukeo.const';
import { BBS_CATEGORY } from '../../defines/protocol';

@Component({
  selector: 'app-pitch-help-popup',
  templateUrl: './pitch-help-popup.component.html',
  styleUrls: ['./pitch-help-popup.component.scss'],
  animations: [triggerDetailPopup],
})
export class PitchHelpPopupComponent implements OnInit {
  @Output() closePopup: EventEmitter<void>;

  public calculatedHeight: number = window.innerHeight - WORD_HELP_POPUP_PADDING;
  readonly BBS_CATEGORY = BBS_CATEGORY;
  readonly RECORDER_HELP_BBS_ID = RECORDER_HELP_BBS_ID;

  constructor() {
    this.closePopup = new EventEmitter<any>();
  }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closePopup.emit();
  }
}
